import axios from 'axios';

export interface KinToneAppData {
  appId: string | number;
  code: string;
  name: string;
  description: string;
  createdAt: string;
  creator: {
    code: string;
    name: string;
  };
  modifiedAt: string;
  modifier: {
    code: string;
    name: string;
  };
  spaceId: string;
  threadId: string;
}


export type KintoneFieldData<T = any> = {
  [key: string]: T;
};

export const getKinToneApps = async (orgSlug: string): Promise<any[]> => {
  const response = await axios.get<{ apps: KinToneAppData[] }>(
    `${process.env.VUE_APP_PROFILE_ROOT}/kintone/apps?orgSlug=${orgSlug}`);
  return response.data.apps;
};

export const getKinTonFields = async (appId: string | number, orgSlug: string): Promise<any[]> => {
  const response = await axios.get(`${process.env.VUE_APP_PROFILE_ROOT}/kintone/fields?app=${appId}&orgSlug=${orgSlug}`);
  return response.data;
};